import React, { useState, useEffect, Suspense } from "react";
import './App.css';
import Navigation from './components/Navbar';
import SmoothScroll from "smooth-scroll";
import JsonData from "./data/data.json";
import 'font-awesome/css/font-awesome.min.css';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { SignUp } from "@clerk/clerk-react";
import RequireAuth from "./components/RequireAuth";
import SignInPage from "./components/SignInPage";
import About from "./components/AboutUs";
import CourseBanner from "./components/CouseBanner";
import Header from "./components/Header";
import PrivacyPolicy from "./companydoc/PrivacyPolicy";
import RefundPolicy from "./companydoc/RefundPolicy";
import TermsAndConditions from "./companydoc/TermsAndConditions";
import SimpleNavbar from "./components/SimpalNavbar";
import StatsShowcase from "./components/StatsShowcase";
import Certifications from "./components/Certifications";

// Lazy-loaded components
const Services = React.lazy(() => import('./components/Services'));
const Projects = React.lazy(() => import('./components/Projects'));
const Contact = React.lazy(() => import('./components/Contact'));
const AllCourses = React.lazy(() => import('./pages/AllCourses'));
const CourseDetails = React.lazy(() => import('./pages/CourseDetails'));
const JoinUs = React.lazy(() => import('./components/JoinUs'));

// Initialize smooth scroll
export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});

// Loading fallback
const Loading = () => <div className="text-white text-center py-20">Loading...</div>;

// Main App
function App() {
  const [landingPageData, setLandingPageData] = useState({});

  useEffect(() => {
    setLandingPageData(JsonData);
  }, []);

  return (
    <Router>
      <AppContent landingPageData={landingPageData} />
    </Router>
  );
}

// AppContent contains Router-aware logic like useLocation
function AppContent({ landingPageData }) {
  const location = useLocation();
  const showSimpleNavbar = ["/privacy-policy", "/refund-policy", "/terms-condition"].includes(location.pathname);

  return (
    <>
      {showSimpleNavbar ? <SimpleNavbar /> : <Navigation />}

      <Suspense fallback={<Loading />}>
        <Routes>
          <Route path="/sign-in" element={<SignInPage />} />
          <Route path="/sign-up" element={<SignUp routing="path" path="/sign-up" />} />

          <Route
            path="/"
            element={
              <>
                <Header />
                <StatsShowcase/>
                <Services data={landingPageData.Services} />
                <CourseBanner />
                <Projects data={landingPageData.Project} />
                <About data={landingPageData.About} />
                <Certifications/>
                <Contact data={landingPageData.Contact} />
              </>
            }
          />

          <Route path="/courses" element={<AllCourses />} />
          <Route path="/course/:id" element={<CourseDetails />} />
          <Route path="/join-us" element={<JoinUs />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/refund-policy" element={<RefundPolicy />} />
          <Route path="/terms-condition" element={<TermsAndConditions />} />

          <Route
            path="/dashboard"
            element={
              <RequireAuth>
                <div className="text-white text-center py-20">Welcome to your Dashboard</div>
              </RequireAuth>
            }
          />
        </Routes>
      </Suspense>
    </>
  );
}

export default App;
